import $api from "@/zapi-frontend/shared/api/axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

type UpdateOrganizationParams = {
  organizationId: number;
  name: string;
  file?: File;
  customerInstructions: string;
};

export function useUpdateOrganization(
  options?: UseMutationOptions<void, AxiosError<{ message: string }>, UpdateOrganizationParams>
) {
  return useMutation({
    mutationKey: ["updateOrganization"],
    mutationFn: async ({ organizationId, name, file, customerInstructions }: UpdateOrganizationParams) => {
      const formData = new FormData();
      formData.append("name", name);
      if (file) formData.append("file", file);
      formData.append("customerInstructions", customerInstructions);

      const response = await $api.patch(`/organizations/${organizationId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return response.data;
    },
    ...options
  });
}
